import scrollLock from 'scroll-lock';

if ($('.js-dropdown-modal-open').length) {
    App.D.on('click', '.js-dropdown-modal-open', function () {
        $(this).siblings('.js-dropdown-modal').toggleClass('_opened');
        $(this).toggleClass('dropdown-modal--opened');

        if ($(this).hasClass('header__location-current')) {
            if (scrollLock.getScrollState()) {
                scrollLock.disablePageScroll();
            }
        }
    });

    App.D.on('click', '.js-dropdown-modal-close', function () {
        $(this).closest('.js-dropdown-modal').removeClass('_opened');
        $(this).removeClass('dropdown-modal--opened');

        let parent = $(this).closest('.js-dropdown-modal').siblings('.header__location-current.js-dropdown-modal-open');

        if (parent.length) {
            parent.removeClass('dropdown-modal--opened');
            if (!scrollLock.getScrollState()) {
                scrollLock.enablePageScroll();
            }
        }
    });
}

App.D.on('click', '.js-dropdown-modal', function (e) {
    if ($(this).hasClass('header__login-dropdown') && !$(e.target).parents().addBack().is('.header__login-links')) {
        $(this).removeClass('_opened');
        $('.js-dropdown-modal-open').removeClass('dropdown-modal--opened');
    }
});

App.H.on('click', function (e) {

    if (!$(e.target).parents().addBack().is('.js-dropdown-modal._opened') & !$('.header__location-current.js-dropdown-modal-open.dropdown-modal--opened').length && !$(e.target).parents().addBack().is('.js-dropdown-modal-open')) {
        $('.js-dropdown-modal').removeClass('_opened');
        $('.js-dropdown-modal-open').removeClass('dropdown-modal--opened');

        if (!scrollLock.getScrollState()) {
            scrollLock.clearQueueScrollLocks();
            scrollLock.enablePageScroll();
        }
    }
});
